mutation UpdateSecuritySettings($input: SecurityUpdateSettingsInput!) {
    securityUpdateSettings(input: $input) {
        success
    }
}
